import {MapDispatcher} from '../core/dispatchers'
import {IMapDispatcher, IPaylodAction, IActionDispatcher} from '../core/interfaces/dispatchers'
import {appExportMapDispatcher} from './appExportMapDispatcher'
import {IMapClickParams, IFeatureLayerInfo} from '../core/interfaces/models'
import {IStore} from '../core/interfaces/reducers'
import {OnClickAction} from '../core/enums/MapEvents'
import {Feature} from '../core/models'
import MapActions from '../core/enums/ActionTypes/MapActions'
import {ServiceHub} from '../core/ServiceHub'
import ExportMapActions from '../core/enums/ActionTypes/ExportMapActions'

class AppMapDispatcher extends MapDispatcher {
  protected onMapClickBefore(
    store: IStore,
    dispatch: (data: any) => void,
    clickParams: IMapClickParams
  ): Array<IFeatureLayerInfo> {
    const featureLayerInfosToIdent: Array<IFeatureLayerInfo> = []
    const layerInfos = store.layerInfos.featureLayerInfos
    for (const i in layerInfos) {
      const layer = layerInfos[i].getLayer(store.map.zoom)
      let isKais = false
      if (layer) {
        layer.moreInfo.urls.forEach(u => {
          if (u.indexOf('MapAccess_') != -1) {
            isKais = true
          }
        })
      }
      let visible = true
      if (isKais) {
        if ((layer as any).getSource().getParams().LAYERS == '') {
          visible = false
        }
      }
      if (layer && layer.getVisible() && !layerInfos[i].sourceDescription.doNotIdentify && visible) {
        featureLayerInfosToIdent.push(layerInfos[i])
      }
    }
    switch (store.map.onClickAction) {
      case OnClickAction.IdentifyToTables:
        // dispatch(featureTableDispatcher.setSyncFeatureTables(featurePayload))
        break
      case OnClickAction.Popup:
        if (featureLayerInfosToIdent.length > 0) {
          const featureMap: Array<{id: string; feature: Feature}> = []
          if (!store.application.mobile) {
            dispatch(
              this.setPopupProperties({
                show: true,
                coordinates: clickParams.mapPoint.getCoordinates() as [number, number],
                maximized: store.map.popup.maximized,
                data: featureMap,
                selectedPage: 0,
                loading: true
              })
            )
          }
        }
        break
      case OnClickAction.ToExport:
        dispatch({
          type: MapActions.SET_HARD_LOADING,
          payload: true
        })
        break
      default:
        break
    }

    return featureLayerInfosToIdent
  }
  public onMapClick(clickParams: IMapClickParams) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      if (store.map.onClickAction == OnClickAction.Disabled) {
        return
      }
      const mapService = store.map.mapService
      if (store.map.onClickDisabled) {
        return
      }
      const featureLayerInfosToIdent = this.onMapClickBefore(store, dispatch, clickParams)
      ServiceHub.gisCrudService
        .identify(
          featureLayerInfosToIdent,
          this.coordinatesToBBOX(clickParams.mapPoint.getCoordinates() as [number, number], mapService)
        )
        .then(results => {
          this.onMapClickAfter(store, dispatch, clickParams, results)
        })
        .catch(e => {
          this.onMapClickError(store, dispatch, clickParams, e)
        })
    }
  }

  protected onMapClickAfter(
    store: IStore,
    dispatch: (data: any) => void,
    clickParams: IMapClickParams,
    results: {layerInfo: IFeatureLayerInfo; features: Feature[]}[]
  ) {
    const featurePayload: {[id: string]: Array<Feature>} = {}
    results.forEach(r => {
      featurePayload[r.layerInfo.url] = r.features
    })
    switch (store.map.onClickAction) {
      case OnClickAction.ToExport:
        dispatch({
          type: MapActions.SET_HARD_LOADING,
          payload: false
        })
        dispatch({
          type: ExportMapActions.SET_FEATURES,
          payload: results
        })
        break

      default:
        super.onMapClickAfter(store, dispatch, clickParams, results)
        break
    }
  }
}

export const appMapDispatcher = new AppMapDispatcher(appExportMapDispatcher) as IMapDispatcher
